module.exports = __webpack_public_path__ + "static/img/xeogen.591ec74.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/xeogen.png
// module id = KuWr
// module chunks = 0